export default {
  // Shared across the platform admin pages
  eyebrowPlatform: 'Platform',
  eyebrowAccount: 'Account',
  companyName: 'Company name',
  timeZone: 'Time zone',
  adminEmail: 'Admin email',
  password: 'Password',
  confirmPassword: 'Confirm',
  passwordHint: 'At least 10 characters.',
  passwordsDoNotMatch: 'Passwords do not match',
  signInLink: 'Sign-in link',
  noCompaniesYet: 'No companies yet',
  inviting: 'Inviting…',
  creating: 'Creating…',
  resendInvite: 'Resend invite',
  colCompany: 'Company',
  colCreated: 'Created',
  colRole: 'Role',
  colTenant: 'Tenant',
  roleSuperAdmin: 'Super admin',
  roleAdmin: 'Admin',
  roleSiteManager: 'Site manager',
  roleReseller: 'Reseller',
  roleEmployee: 'App user',

  // Add company admin dialog
  addAdminTitle: 'Add admin',
  addAdminDescription: 'Adds a new admin account to {company}.',
  addAdminDoneTitle: 'Admin added',
  addAdminNewAdmin: 'New admin',
  addAdminAdding: 'Adding…',

  // Assign reseller dialog
  assignResellerTitle: 'Assign reseller',
  assignResellerDescription: 'Attribute {company} to a reseller for commission tracking.',
  assignResellerLabel: 'Reseller',
  assignResellerNone: 'No reseller',
  assignResellerUpdated: 'Reseller updated.',

  // Billing page
  billingTitle: 'Billing',
  billingDescription: "Subscriptions, trials and recurring revenue across every tenant. Open a company's payments to see its invoices, charges and refunds.",
  subStatusNone: 'No subscription',
  subStatusTrialing: 'Trial',
  subStatusActive: 'Active',
  subStatusPastDue: 'Payment failed',
  subStatusCanceled: 'Cancelled',
  subStatusIncomplete: 'Incomplete',
  subStatusIncompleteExpired: 'Checkout expired',
  subStatusExpired: 'Trial ended',
  sourceTrial: 'Granted trial',
  billingTrialEnded: 'Trial ended for {company}.',
  billingSubscriptionCancelled: 'Subscription cancelled for {company}.',
  statMrr: 'Monthly recurring revenue',
  statPayingCompanies: 'Paying companies',
  statOnTrial: 'On trial',
  billingEmptyMessage: 'Companies will appear here once created.',
  colBilledBy: 'Billed by',
  colTrialEnds: 'Trial ends',
  colSeats: 'Seats',
  colMrr: 'MRR',
  grantTrial: 'Grant trial',
  extend: 'Extend',
  endTrial: 'End trial',
  cancel: 'Cancel',
  payments: 'Payments',
  endTrialTitle: 'End this trial',
  endTrialMessage: "{company}'s trial will end now. Nothing is charged; you can grant another trial later.",
  cancelSubscriptionTitle: 'Cancel this subscription',
  cancelSubscriptionMessage: "{company}'s Stripe subscription will be cancelled immediately and they won't be billed again. Cancelling can't be undone — they'd have to subscribe again.",
  cancelSubscriptionConfirm: 'Cancel subscription',

  // Companies page
  companiesTitle: 'Companies',
  companiesDescription: 'Each company is an isolated tenant with its own sites, employees and users.',
  newCompany: 'New company',
  companiesEmptyMessage: 'Create the first tenant and its admin account.',
  colTimeZone: 'Time zone',
  colId: 'ID',
  logIn: 'Log in',
  resellerButton: 'Reseller',
  inviteSentToCompanyAdmin: "Invite sent to {company}'s admin.",
  loginAsTitle: 'Log in to this company',
  loginAsMessage: "You'll be signed in as \"{company}\"'s admin, in place of your super admin session. It is recorded in that admin's activity log, and a banner stays on screen while you are in. Sign back in with your own account to return.",

  // Company form dialog
  companyLogoHint: "Shown to this company's crew in the app. PNG with transparency works best.",
  companyUpdated: 'Company updated.',
  companyInvited: 'Company invited',
  companyCreated: 'Company created',
  firstAdmin: 'First admin',
  companyInviteSent: 'We emailed {email} a link to choose their password.',
  companyInviteFailed: "The company was created but the invite email couldn't be sent. Use Resend invite on the companies list to try again.",
  editCompany: 'Edit company',
  newCompanyDescription: 'Creates the tenant and its first admin account.',
  firstAdminAccount: 'First admin account',
  emailInvite: 'Email them an invite',
  emailInviteHint: 'They choose their own password from the link. Untick to set one yourself.',
  createAndInvite: 'Create and invite',
  createCompany: 'Create company',

  // Platform dashboard
  dashboardTitle: 'Dashboard',
  dashboardDescription: 'A cross-tenant view of every company and user on CrewPresence.',
  statTotalUsers: 'Total users',
  statSuperAdmins: 'Super admins',
  statSuperAdminsHint: 'Platform-level accounts',
  statActiveUsers: 'Active users',
  statInactive: '{count} inactive',
  manage: 'Manage',
  dashboardEmptyMessage: 'Create the first tenant to get started.',
  colUsers: 'Users',

  // Invite reseller dialog
  inviteResellerTitle: 'Invite reseller',
  inviteResellerDescription: "They're approved straight away and emailed a link to set their password.",
  resellerInvited: 'Reseller invited',
  resellerInviteSent: 'An email with a set-password link is on its way to {email}.',
  resellerInviteFailed: '{email} was added, but the invite email couldn\'t be sent. Use "Resend invite" on the Approved tab to try again.',
  contactName: 'Contact name',
  phoneOptional: 'Phone (optional)',
  resellerEmailHint: 'Becomes their reseller portal login.',
  sendInvite: 'Send invite',

  // Invite tenant user dialog
  inviteUserTitle: 'Invite user',
  inviteUserDescription: 'Creates a new account in a tenant.',
  userInvited: 'User invited',
  newUser: 'New user',
  selectTenant: 'Select a tenant',

  // Payments dialog
  paymentsTitle: 'Payments · {company}',
  paymentsDescription: 'Invoices and charges as Stripe holds them, newest first.',
  nothingChargedTitle: 'Nothing charged yet',
  nothingChargedMessage: 'No invoices or charges exist for this company in Stripe.',
  chargeFailed: 'Failed',
  chargePending: 'Pending',
  chargeRefunded: 'Refunded',
  chargePartlyRefunded: 'Partly refunded',
  chargePaid: 'Paid',
  invoiceStatusPaid: 'Paid',
  invoiceStatusOpen: 'Open',
  invoiceStatusUncollectible: 'Uncollectible',
  invoiceStatusVoid: 'Void',
  invoiceStatusDraft: 'Draft',
  totalCharged: 'Charged',
  totalRefunded: 'Refunded',
  totalNet: 'Net',
  chargesHeading: 'Charges',
  noCharges: 'No charges have been attempted yet.',
  colFor: 'For',
  colAmount: 'Amount',
  colRefunded: 'Refunded',
  chargeForInvoice: 'Invoice {number}',
  chargeFallback: 'Payment',
  receipt: 'Receipt',
  refund: 'Refund',
  invoicesHeading: 'Invoices',
  noInvoices: 'No invoices yet.',
  colInvoice: 'Invoice',
  colLinks: 'Links',
  invoiceDraft: 'Draft',
  view: 'View',
  openInStripe: 'Open customer in Stripe',

  // Profile page
  profileTitle: 'Profile',
  profileDescription: 'Your platform admin account.',
  userId: 'User ID',

  // Refund dialog
  refundReasonRequested: 'Requested by customer',
  refundReasonDuplicate: 'Duplicate charge',
  refundReasonFraudulent: 'Fraudulent',
  refundedTo: 'Refunded {amount} to {company}.',
  refundTitle: 'Refund payment',
  refundDescription: '{amount} charged to {company}. The money goes back to their card.',
  refundDescriptionInvoice: '{amount} charged to {company} for invoice {number}. The money goes back to their card.',
  refundAmountLabel: 'Amount ({currency})',
  refundAmountError: 'Enter an amount from 0.01 to {max}.',
  refundHintPartial: '{refunded} already refunded; {remaining} left.',
  refundHintUpTo: 'Up to {amount}.',
  refundReason: 'Reason',
  refundReverseTransfer: "Also take back the reseller's commission on this amount",
  refunding: 'Refunding…',
  refundAmount: 'Refund {amount}',

  // Resellers page
  resellersTitle: 'Resellers',
  resellersDescription: 'Applications to become a CrewPresence reseller, and everyone already approved.',
  resellerStatusPending: 'Pending',
  resellerStatusApproved: 'Approved',
  resellerStatusRejected: 'Rejected',
  noPendingApplications: 'No pending applications',
  noApprovedApplications: 'No approved applications',
  noRejectedApplications: 'No rejected applications',
  nothingHere: 'Nothing here right now.',
  colContact: 'Contact',
  colApplied: 'Applied',
  colTenants: 'Tenants',
  colLastLogin: 'Last login',
  never: 'Never',
  reject: 'Reject',
  approve: 'Approve',
  applicationRejected: 'Application rejected.',
  rejectTitle: 'Reject application',
  rejectDescription: "Reject {company}'s reseller application.",
  rejectNotes: 'Notes (optional)',
  rejectNotesPlaceholder: 'Reason, for your own records',
  rejecting: 'Rejecting…',
  resellerApproved: "{company} approved — they'll receive an email to set a password.",
  inviteSentTo: 'Invite sent to {email}.',
  approveTitle: 'Approve this reseller',
  approveMessage: '{company} will be approved and sent an email to set a password for their reseller portal login.',

  // Reset MFA
  resetMfa: 'Reset MFA',
  resetMfaMessage: "Reset two-step verification for {email}? They'll be able to sign in with just their password until they set MFA up again.",
  mfaResetFor: 'MFA reset for {email}.',

  // Trial dialog
  grantTrialTitle: 'Grant a trial',
  extendTrialTitle: 'Extend trial',
  grantTrialDescription: 'Give {company} a free trial. No card is taken and nothing is charged when it ends.',
  extendTrialDescription: "Add time to {company}'s trial.",
  trialGranted: 'Trial granted to {company}.',
  trialExtended: 'Trial extended for {company}.',
  trialLength: 'Trial length',
  trialPresetDays: '{count} days',
  trialLengthDays: 'Trial length (days)',
  daysToAdd: 'Days to add',
  trialDaysError: 'Enter a whole number of days from 1 to {max}.',
  trialEndsHint: 'Trial ends: {date}',
  newEndDateHint: 'New end date: {date}',

  // User edit page
  usersTitle: 'Users',
  userNotFound: 'User not found',
  platformAdmin: 'Platform admin',
  userUpdated: 'User updated.',
  resetPassword: 'Reset password',
  resetPasswordSelfHint: "You can't reset your own password here — use your profile page.",
  resetPasswordHint: 'Leave blank to keep the current password. Resetting signs the user out of every session.',
  roleSelfHint: "You can't change your own role.",
  platformAdminNoRole: 'Platform super admin — no role to change.',
  siteAssignmentNote: "Site assignment is managed from this user's own company — sign in as their tenant admin to change it.",
  activeSelf: "Active. You can't deactivate yourself",
  activeOther: 'Active. Can sign in to this portal',
  mfaTitle: 'Two-step verification',
  mfaOnMessage: "Turned on. Reset it if they've lost their authenticator app and recovery codes.",

  // Users page
  usersDescription: "Every person who can sign in across the platform — super admins and every tenant's users.",
  inviteUser: 'Invite user',
  filterAllRoles: 'All roles',
  filterSuperAdmins: 'Super admins',
  filterAdmins: 'Admins',
  filterSiteManagers: 'Site managers',
  filterResellers: 'Resellers',
  filterEmployees: 'App users',
  searchUsers: 'Search by email or tenant',
  detailsTitle: "Details",
  fieldName: "Name",
  fieldLastSignIn: "Last sign-in",
  fieldNever: "Never",
  fieldDevice: "Phone",
  fieldDevicePaired: "Paired, app {version}",
  fieldDeviceNone: "Not paired",
  fieldLastSeen: "Last seen",
  accessTitle: "Access",
  accessMessage: "Change what this person can do. Tenant admins manage their own company; super admins manage every tenant.",
  makeAdmin: "Make tenant admin",
  makeSuperAdmin: "Make super admin",
  adminDialogTitle: "Make {email} a tenant admin",
  adminDialogMessage: "They will be able to sign in to the web portal and manage {company}.",
  adminPasswordHint: "They have no portal password yet. Set an initial password (10+ characters) they can use to sign in.",
  initialPassword: "Initial password",
  adminPromoted: "{email} is now a tenant admin",
  superDialogTitle: "Make {email} a super admin",
  superWarningTitle: "This gives access to every tenant",
  superWarning: "A super admin can see and change all companies, users, billing and data on the platform. Only continue if you are certain. This person's tenant portal login is replaced by the platform login.",
  superSetPasswordNote: "{email} will get an email with a link to choose their own password, and has to do that before they can sign in.",
  superYourPassword: "Your password",
  superYourPasswordHint: "Enter your own password to confirm.",
  superPromoted: "{email} is now a super admin",
  passwordsDontMatch: "Passwords don't match",
  roleEmployeeNote: "Uses the mobile app only. No portal login.",
  usersTotal: '{count} total',
  superAdminCountOne: '{count} super admin',
  superAdminCountOther: '{count} super admins',
  companyCountOne: '{count} company',
  companyCountOther: '{count} companies',
  noUsers: 'No users',
  noUsersMatch: 'No users match this filter.',
  you: '(you)',
  platform: 'Platform',
  active: 'Active',
  inactive: 'Inactive',
  companyLanguage: 'Language',
  companyLanguageHint: 'Emails and notifications for this company’s people, unless they pick their own.',
}
